;(function () {

	var KEY = 'wtoy_age_verified';

	function markVerified() {
		try {
			document.body.classList.add('wtoy-age-verified');
		} catch (e) {}
	}

	var alreadyVerified = false;
	try {
		if (sessionStorage.getItem(KEY) === '1') {
			markVerified();
			alreadyVerified = true;
		}
	} catch (e) {}

	// 若已驗證過，本頁不再顯示詢問
	if (alreadyVerified) {
		return;
	}

	// 未開啟覆蓋層時，僅處理 body 標記（用於移除馬賽克），不顯示彈窗
	if (!window.WTOY_AGE_GATE || window.WTOY_AGE_GATE.enabled !== '1') {
		return;
	}

	function createModal() {
		var backdrop = document.createElement('div');
		backdrop.className = 'wtoy-age-backdrop';

		var modal = document.createElement('div');
		modal.className = 'wtoy-age-modal';

		var card = document.createElement('div');
		card.className = 'wtoy-age-card';

		var title = document.createElement('div');
		title.className = 'wtoy-age-title';
		title.innerHTML = '<span class="icon">⚠️</span><span>本分類內容涉及成人情節，僅限年滿 18 歲之成年人瀏覽。</span>';

		var content = document.createElement('div');
		content.className = 'wtoy-age-content';
		content.textContent =
			'依據中華民國法律規定：\n\n'
			+ '未滿 18 歲之兒童及少年不得瀏覽、使用或購買任何成人性相關內容。\n\n'
			+ '未經同意散布、轉傳、公開或利用他人私密影像均屬違法，並依《性影像犯罪防制條例》處罰。\n\n'
			+ '若您未滿 18 歲，請立即離開本分類。\n\n'
			+ '若您係成年人，仍須自行評估內容是否符合當地法令與道德規範。\n\n'
			+ '進入本網站代表您已閱讀並同意：\n\n'
			+ '您已年滿 18 歲以上，並具完全行為能力。\n\n'
			+ '本網站提供內容僅供個人使用，禁止分享、轉傳、下載或外流。\n\n'
			+ '違反法律之行為與後果由使用者自行負責，與本站無涉。\n\n'
			+ '使用者不得利用本站從事任何違法、傷害他人、暴力、威脅等行為。\n\n';

		var actions = document.createElement('div');
		actions.className = 'wtoy-age-actions';

		var btnEnter = document.createElement('button');
		btnEnter.className = 'wtoy-age-btn primary';
		btnEnter.textContent = '【我已滿 18 歲，進入網站】';

		var btnLeave = document.createElement('button');
		btnLeave.className = 'wtoy-age-btn secondary';
		btnLeave.textContent = '【我未滿 18 歲，離開網站】';

		actions.appendChild(btnEnter);
		actions.appendChild(btnLeave);

		card.appendChild(title);
		card.appendChild(content);
		card.appendChild(actions);
		modal.appendChild(card);

		function close() {
			try { document.body.style.overflow = ''; } catch (e) {}
			if (modal && modal.parentNode) modal.parentNode.removeChild(modal);
			if (backdrop && backdrop.parentNode) backdrop.parentNode.removeChild(backdrop);
		}

		btnEnter.addEventListener('click', function () {
			try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
			markVerified();
			close();
		});
		btnLeave.addEventListener('click', function () {
			var url = (window.WTOY_AGE_GATE && window.WTOY_AGE_GATE.leaveUrl) ? window.WTOY_AGE_GATE.leaveUrl : '/';
			window.location.href = url;
		});

		document.body.appendChild(backdrop);
		document.body.appendChild(modal);
		try { document.body.style.overflow = 'hidden'; } catch (e) {}
	}

	function addGuardTargetsForSingle() {
		// Blocksy / Woo 預設商品圖片容器
		var targets = [
			document.querySelector('.ct-product-gallery-container'),
			document.querySelector('.woocommerce-product-gallery')
		];
		for (var i = 0; i < targets.length; i++) {
			if (targets[i]) targets[i].classList.add('wtoy-age-guard-target');
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () {
			if (document.body && document.body.classList.contains('single-product')) {
				addGuardTargetsForSingle();
			}
			createModal();
		});
	} else {
		if (document.body && document.body.classList.contains('single-product')) {
			addGuardTargetsForSingle();
		}
		createModal();
	}
})(); 

